import * as actionTypes from '../../constants/actionTypes';
import cloneDeep from "lodash/cloneDeep";
// import hardCodedDiscounts from "./hardCodedDiscounts";

const initialState = {
  // discountSections: hardCodedDiscounts,
  workSheetsCount: 1, // we have always one worksheet
  workSheetsActiveIndex: 0,
  discountsReceived: false,
  discountSections: [],
  discountSectionsBackup: [],
  enableWorksheet: false,
  enableWorksheetForClients: false,
  workSheetWizardSelectionsActive: false,
  workSheetWizardSelectionsGroupSelected: null,
  workSheetWizardSelectionsClick: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    // case actionTypes.DISCOUNTS_SET_DISCOUNTS:
    case actionTypes.DISCOUNTS_SET_WORKSHEETS_ACTIVE_INDEX:
    case actionTypes.DISCOUNTS_TOGGLE_ENABLE_WORKSHEET:
    case actionTypes.DISCOUNTS_TOGGLE_ENABLE_WORKSHEET_FOR_CLIENTS:
    case actionTypes.DISCOUNTS_SET_WORKSHEET_COUNT:
    case actionTypes.DISCOUNTS_SET_IS_LOWES_IME_ACTIVE:
    case actionTypes.DISCOUNTS_SET_WIZARD_SELECTIONS_ACTIVE:
      return Object.assign({}, state, {
        ...action.payload
      });
    case actionTypes.DISCOUNTS_SECTIONS_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        discountsReceived: true,
        discountSectionsBackup: cloneDeep(action.payload.discountSections)
      });
    case actionTypes.DISCOUNTS_SECTIONS_RESET:
      return Object.assign({}, state, {
        discountsReceived: false,
        discountSections: [],
        discountSectionsBackup: [],
      });
    case actionTypes.DISCOUNTS_REVERT_CHANGES:
      return Object.assign({}, state, {
        discountSections: cloneDeep(state.discountSectionsBackup),
      });
    case actionTypes.DISCOUNTS_SET_SECTIONS:
      return Object.assign({}, state, {
        discountSections: [...action.payload.discountSections]
      });
    default:
      return state;
  }
}
